import {Injectable} from '@angular/core';
import {SecureTable} from '../secure.table';
import {TtProductEntry} from '../../interfaces/time-tracking/tt-product-entry';
import {db} from '../db.service';
import {DefaultAdapter} from '../../adapters/default.adapter';
import {TtProductEntryFactory} from '../../factories/time-tracking/tt-product-entry-factory';

@Injectable({
  providedIn: 'root'
})
export class TtProductEntriesTable extends SecureTable<TtProductEntry> {
  constructor() {
    super(db.ttProductEntries);
    this._tableSyncSettings = {
      error: false,
      syncMode: 'default',
      dependencies: [],
      // @ts-ignore
      adapter: new DefaultAdapter<TtProductEntry>({
        api: ['tt-product-entries'],
        fromObject: TtProductEntryFactory.fromObject,
        toRemote: TtProductEntryFactory.toRemote
      })
    };
  }

  /**
   *
   * @param ttActivityEntryUuid
   */
  public async getByTtActivityEntryUuid(ttActivityEntryUuid: string): Promise<TtProductEntry[]> {
    return this.table.where('ttActivityEntryUuid').equals(ttActivityEntryUuid).toArray();
  }

  /**
   *
   * @param employeeId
   */
  public getSelfConsumption(employeeId: number): Promise<TtProductEntry[]> {
    return this.table
      .where('employeeId')
      .equals(employeeId)
      .filter(_ttProductEntry => !!!_ttProductEntry.customerId)
      .toArray();
  }

  /**
   *
   * @param ttActivityEntryUuid
   * @param withoutSync
   */
  public async removeByTtActivityEntryUuid(ttActivityEntryUuid: string, withoutSync: boolean = false): Promise<void> {
    const ttProductEntries = await this.getByTtActivityEntryUuid(ttActivityEntryUuid);
    await this.removeMany(ttProductEntries.map(_ttProductEntry => _ttProductEntry.uuid), withoutSync);
  }

  /**
   *
   * @param ttActivityEntryUuid
   * @param ttProductEntries
   */
  public async addOrUpdateManyByTtActivityEntryUuid(ttActivityEntryUuid: string, ttProductEntries: TtProductEntry[]): Promise<void> {
    const allTtProductEntries = await this.getByTtActivityEntryUuid(ttActivityEntryUuid);

    const ttProductEntriesToUpdate = ttProductEntries.filter(
      _ttProductEntry => allTtProductEntries.some(
        _allTtProductEntry => _allTtProductEntry.uuid === _ttProductEntry.uuid
      )
    );

    const ttProductEntriesToAdd = ttProductEntries.filter(
      _ttProductEntry => !allTtProductEntries.some(
        _allTtProductEntry => _allTtProductEntry.uuid === _ttProductEntry.uuid
      )
    );

    const ttProductEntriesToRemove = allTtProductEntries.filter(
      _allTtProductEntry => !ttProductEntries.some(
        _ttProductEntry => _ttProductEntry.uuid === _allTtProductEntry.uuid
      )
    );

    await this.removeMany(ttProductEntriesToRemove.map(_ttProductEntry => _ttProductEntry.uuid));
    await this.updateMany(ttProductEntriesToUpdate);
    await this.addMany(ttProductEntriesToAdd);
  }

}
